import { render } from "./ConsultaAfiliados.vue?vue&type=template&id=70dcb428"
import script from "./ConsultaAfiliados.vue?vue&type=script&lang=js"
export * from "./ConsultaAfiliados.vue?vue&type=script&lang=js"

import "./ConsultaAfiliados.vue?vue&type=style&index=0&id=70dcb428&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__